/* 甘寧傳共用的小工具：史書上有名、但不是可選武將的人（凌操、朱光），高樓、柴營的畫法，引弓一箭 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { H } from '../../heroes/define.ts';

const P = (id, name, sub, faction, role, weapon, look, skills) => H(id, name, sub, faction, role, weapon, Object.assign({ fx: '#ffd8a0' }, look), skills);
export const GN_PEOPLE = {
  lingcao: P('lingcao', '凌操', '破賊校尉', 'wu', '戰士', 'sword', { beard: 'mustache', eye: 'fierce', c: { cape: '#a83a2a' } }, [
    ['先登', 'charge', '衝撞造成 {90/90/90/90} 傷害。'], ['冠軍', 'crescent', '揮刀造成 {100/100/100/100} 傷害。'], ['履鋒', 'spin', '每圈 {45/45/45/45} 傷害。'], ['輕舟', 'slam', '{150/150/150} 傷害。']]),
  zhuguang: P('zhuguang', '朱光', '廬江太守', 'wei', '戰士', 'sword', { beard: 'long', bulk: 1.1, c: { cape: '#2b3f6e' } }, [
    ['揮刀', 'crescent', '造成 {90/90/90/90} 傷害。'], ['突圍', 'charge', '衝撞造成 {80/80/80/80} 傷害。'], ['迴刀', 'spin', '每圈 {45/45/45/45} 傷害。'], ['困守', 'slam', '{140/140/140} 傷害。']]),
};

// 引弓：甘寧「以善射」——朝 t 射一箭（看得到、會追著目標飛的投射物），只打 t
export function shoot(w, u, t, dmg) {
  const dx = t.x - u.x, dy = (t.y - u.y) / SG.K, L = Math.hypot(dx, dy) || 1;
  w.shootProj(u, { dir: [dx / L, dy / L], speed: 1500, range: L + 400, homing: t, shape: 'arrow', col: '#ffe28a', rad: 20,
    onHit: (o) => { if (!o.alive) return true; w.damage(u, o, dmg, { stagger: 0.3 }); w.fx({ k: 'spark', x: o.x, y: o.y - 40, col: '#ffe28a' }); return true; } });
}

// 高樓：木架搭的箭樓，頂上有女牆；樓上的弓手（f.T 記著上一次放箭的時間，放箭時閃一下）
export function tower(ctx, f, T) {
  const { poly } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y);
  SG.draw.castShadow(ctx, 10, 4, 60, 18, 170, 0.35);
  ctx.strokeStyle = '#4a3220'; ctx.lineWidth = 6;
  for (const [a, b] of [[[-40, 0], [-28, -170]], [[40, 0], [28, -170]], [[-40, 0], [28, -110]], [[40, 0], [-28, -110]], [[-34, -60], [34, -60]]]) { ctx.beginPath(); ctx.moveTo(a[0], a[1]); ctx.lineTo(b[0], b[1]); ctx.stroke(); }
  poly(ctx, [[-44, -166], [44, -166], [44, -196], [-44, -196]], '#7a5634', 2);
  for (let i = -36; i <= 28; i += 20) poly(ctx, [[i, -196], [i + 10, -196], [i + 10, -210], [i, -210]], '#6a4a2c', 1.4);
  ctx.strokeStyle = '#3a2a18'; ctx.lineWidth = 3; ctx.beginPath(); ctx.moveTo(36, -196); ctx.lineTo(36, -260); ctx.stroke();
  poly(ctx, [[36, -258], [66, -252 + Math.sin(T * 4) * 3], [36, -232]], '#3b5a99', 1.4);
  if (f.fired && T - f.fired < 0.3) { ctx.fillStyle = 'rgba(255,220,150,.7)'; ctx.beginPath(); ctx.arc(0, -205, 18, 0, Math.PI * 2); ctx.fill(); }
  ctx.restore();
}
// 柴營：關羽「結柴營」——一圈削尖的柴木圍著一頂帳
export function chaiying(ctx, f, T) {
  const { poly } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y);
  SG.draw.castShadow(ctx, 6, 4, 110, 26, 60, 0.3);
  poly(ctx, [[-50, 0], [50, 0], [0, -70]], '#3e7b50', 2);
  for (let i = 0; i < 14; i++) { const a = (i / 14) * Math.PI * 2, x = Math.cos(a) * 100, y = Math.sin(a) * 34; ctx.strokeStyle = '#6a4a2c'; ctx.lineWidth = 5; ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x * 1.05, y - 38); ctx.stroke(); }
  ctx.restore();
}
